<main id="main">
    <div class="otp">
        <div class="otp__header">
            <span class="otp__header-title">{{ 'otp.header.title' | i18n }}</span>
        </div>
        <div class="otp__form">
            <div class="otp__form-title">
                <div class="otp__form-title--green">{{ 'otp.form.enter-code' | i18n }}</div>
                <div>{{ 'otp.form.on-your-machine' | i18n }}</div>
            </div>
            <div class="otp__form-group">
                <div class="grid-12">
                    <form id="codeForm">
                        <input maxlength="1" type="number" (keypress)="numberOnly($event)" (keyup)="checkPassword()" class="grid-2 textfield" id="firstCode" name="firstCode" [(ngModel)]="firstCode" />

                        <input maxlength="1" type="number" (keypress)="numberOnly($event)" (keyup)="checkPassword()" class="grid-2 textfield" id="secondeCode" name="secondeCode" [(ngModel)]="secondeCode" />

                        <input maxlength="1" type="number" (keypress)="numberOnly($event)" (keyup)="checkPassword()" class="grid-2 textfield" id="thirdCode" name="thirdCode" [(ngModel)]="thirdCode" />

                        <input maxlength="1" type="number" (keypress)="numberOnly($event)" (keyup)="checkPassword()" class="grid-2 textfield" id="fourthCode" name="fourthCode" [(ngModel)]="fourthCode" />

                        <input maxlength="1" type="number" (keypress)="numberOnly($event)" (keyup)="checkPassword()" class="grid-2 textfield" id="fifthCode" name="fifthCode" [(ngModel)]="fifthCode" />

                        <input maxlength="1" type="number" (keypress)="numberOnly($event)" (keyup)="checkPassword()" class="grid-2 textfield" id="sixCode" name="sixCode" [(ngModel)]="sixCode" />
                    </form>
                </div>
            </div>
        </div>
    </div>
</main>
